/**
 * Yazılım (1920 deposu) siparişlerinde son kullanıcı adresine eklenen zorunlu
 * "Reseller" alanının tek kaynak kuralı.
 *
 * Backend karşılığı: Index.Group.Core/Models/Payment/ResellerRule.cs
 * İkisi birlikte değiştirilmelidir — değer siparişte SAP'e PURCH_NO_S sahasında gider
 * (SAP karşılığı BSTKD_E, CHAR(35)). Daha önce INCOTERMS2L (INCO2_L, CHAR(70)) sahasında
 * gönderiliyordu; uzunluk sınırı bu nedenle 70'ten 35'e düştü.
 * Aynı saha iQuote siparişlerinde "IQ:{HpeQuoteId}" ile doluyor; iki senaryo backend'de
 * bu ön ek ile ayirt edilir (CreateOrder.IquotePurchNoPrefix), iQuote değerinin üzerine yazılmaz.
 *
 * ÜRÜN AYIRT EDİCİSİ — MARKA STRING'İ DEĞİL:
 * Bir ürünün Kaspersky olup olmadığı, kod tabanının kendi tanımıyla belirlenir
 * (`BasketService.KasperskyBasketControl`): şirket Netex + `QuotaNo == "145"`.
 * Bu ayırt edici artık kasperskyProduct.ts'de tek kaynakta duruyor; aşağıdaki
 * RESELLER_QUOTA_NO oradan türetilir.
 * `Product.Brand` alanı bu iş için kullanılmaz; o alan farklı yazımlarla geliyor
 * (ör. HomePageHeader marka adını 'KASPERSKY' olarak karşılaştırıyor) ve tam
 * eşitlik kontrolü sessizce hep false döner.
 */

import { KASPERSKY_BRAND_LABEL, KASPERSKY_QUOTA_NO } from './kasperskyProduct'

/** Alanın kabul ettiği en fazla karakter sayısı. SAP PURCH_NO_S (BSTKD_E, CHAR(35)) sahası ile uyumlu. */
export const RESELLER_MAX_LENGTH = 35

/** Kaspersky ürünlerinin kota numarası. Bkz. kasperskyProduct.ts. */
export const RESELLER_QUOTA_NO = KASPERSKY_QUOTA_NO

/** Kullanıcıya gösterilen marka etiketi. Kural kontrolünde kullanılmaz, yalnız metinlerde. */
export const RESELLER_BRAND_LABEL = KASPERSKY_BRAND_LABEL

/** Kuralın geçerli olduğu şirket (Netex) SAP kodu. */
export const RESELLER_COMPANY_SAP_CODE = 2300

/** Kuralın geçerli olduğu depo (yazılım deposu). */
export const RESELLER_WAREHOUSE_CODE = '1920'

/**
 * Reseller alanı bu ürün/şirket/depo bileşimi için zorunlu mu?
 * Kota bilgisi hiç gelmezse false döner — alan gizli kalır, sipariş bloklanmaz.
 */
export const isResellerRequired = (
  quotaNo: string | undefined | null,
  companySapCode: number | undefined | null,
  warehouseCode: string | undefined | null
): boolean =>
  Number(companySapCode) === RESELLER_COMPANY_SAP_CODE &&
  (warehouseCode ?? '').trim() === RESELLER_WAREHOUSE_CODE &&
  (quotaNo ?? '').trim() === RESELLER_QUOTA_NO

/** Boş/whitespace değerleri boş string'e, dolu değerleri kırpılmış hâline çevirir. */
export const normalizeReseller = (value: string | undefined | null): string => (value ?? '').trim()
